<template>
  <v-card class="mainContainer">
    <v-card class="textBlock" elevation="10">
      <h1 :style="`color: ${$vuetify.theme.primary}`">
        {{$translate('REGISTER_PRIVACY_STATEMENT')}}</h1>
      <p v-html="privacyStatement"/>
    </v-card>
  </v-card>
</template>

<script>
import * as dssRequest from '../api/dssRequest';
import BaseObject from '../objects/BaseObject';
import {store} from "../store";
import appConfig from "../../config/app_config";
import {mapGetters} from "vuex";

export default {
  components: {
  },
  computed: {
    ...mapGetters({
      _userLanguage: 'getUserLanguage',
    }),
  },
  data() {
    return {
      privacyStatement: '',
    };
  },
  watch: {
    _userLanguage(newV, oldV) {
      if (Number(newV) !== Number(oldV)) {
        this.getAccountInfo();
      }
    },
  },
  mounted() {
    this.getAccountInfo();
    console.log("Lorenzo this.$store.getters.getUserLanguage", this.$store.getters.getUserLanguage);
  },
  methods: {
    getAccountInfo() {
      const payload = {};
      if (this.$store.getters.getRegion && this.$store.getters.getRegion !== "activateUser") {
        this.payload = {
          Region: this.$store.getters.getRegion
        };
      } else {
        if (this.$route.path == "/activateUser") {
          this.payload = {
            Region: this.$route.query.AccountName
          }
        } else {
          this.payload = {
            Region: this.$route.params.account_id
          }
        }
      }
      dssRequest.doRequest(
        response => {
          console.log("The generic call getAccountInfo on " +
            "PrivacyStatement.vue was successful", response);
          this.privacyStatement = response.data.Translations.PrivacyStatement;
        },
        error => {
          console.log("The generic call getAccountInfo on PrivacyStatement.vue was successful", error);
        },
        "getAccountInfo",
        appConfig.dss.accountManagerObjectId,
        payload,
        30000,
        false,
      );
    },
  },
};
</script>

<style scoped lang="scss">
  .mainContainer {
    background: white;
    margin-top: 4em !important;
    margin-left: -3.4em;
    margin-right: -3.4em;
    margin-bottom: -2em;
    padding-bottom: 1em;
    min-height: 500px;
  }
  .textBlock {
    width: 1000px !important;
    margin: 0 auto;
    margin-top: 2em;
    margin-bottom: 50px;
    padding: 20px;
  }
</style>
